import { CellRenderType, ComponentTester } from './renderCell.js';
import { RenderPrimitive } from './renderPrimitive.js';

export const RenderDateString: ComponentTester<CellRenderType.dateString> = (props) => {
  return <RenderPrimitive classes="u-mT-xs u-mB-xs u-textBold" {...props} />;
};
